import EmberObject, { get } from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class StripeInvoiceAdapter extends EmberObject {
  @service
  ajax

  find(id) {
    return get(this, "ajax").requestFromAdapter(ENV.API_ROOT + "/stripe_invoices/" + id)
  }
}
